
import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t bg-slate-50">
      <div className="container py-8 md:py-12">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-6 md:mb-0">
            <span className="font-bold">Clinic Brand Here</span>
          </div>
          <div className="text-sm text-slate-600">
            <p>© {new Date().getFullYear()} Clinic Brand Here. Educational information only.</p>
            <p className="mt-1">Not medical advice. Consult your healthcare provider.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
